import { Routes, Route, Navigate } from "react-router-dom";
import { AppLayout } from "@/layouts/AppLayout";
import { AuthLayout } from "@/layouts/AuthLayout";
import { OnboardingLayout } from "@/layouts/OnboardingLayout";
import { JoinLayout } from "@/layouts/JoinLayout";

import { DashboardPage } from "@/pages/Dashboard";
import { PostsPage } from "@/pages/Posts";
import { PostDetailPage } from "@/pages/PostDetail";
import { ChatsPage } from "@/pages/Chats";
import { ChatDetailPage } from "@/pages/ChatDetail";
import { ChoresPage } from "@/pages/Chores";
import { ChoreboardPage } from "@/pages/Choreboard";
import { EventsPage } from "@/pages/Events";
import { GroceryPage } from "@/pages/Grocery";
import { MealsPage } from "@/pages/Meals";
import { NotificationsPage } from "@/pages/Notifications";
import { ResponsibilitiesPage } from "@/pages/Responsibilities";
import { ShoppingPage } from "@/pages/Shopping";
import { WeekendPage } from "@/pages/Weekend";
import { AccountPage } from "@/pages/Account";
import { AccountHouseholdsPage } from "@/pages/AccountHouseholds";
import { MemberDetailPage } from "@/pages/MemberDetail";
import { MembersPage } from "@/pages/Members";
import { AdminCookbookPage } from "@/pages/AdminCookbook";
import { CookbookPage } from "@/pages/Cookbook";

import { LoginPage } from "@/pages/Login";
import { RegisterPage } from "@/pages/Register";
import { AuthActionPage } from "@/pages/AuthAction";

import { OnboardingPage } from "@/pages/Onboarding";
import { JoinPage } from "@/pages/Join";
import { NotFoundPage } from "@/pages/NotFound";

export function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/posts" element={<PostsPage />} />
        <Route path="/posts/:postId" element={<PostDetailPage />} />
        <Route path="/chats" element={<ChatsPage />} />
        <Route path="/chats/:chatId" element={<ChatDetailPage />} />
        <Route path="/chores" element={<ChoresPage />} />
        <Route path="/choreboard" element={<ChoreboardPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/grocery" element={<GroceryPage />} />
        <Route path="/meals" element={<MealsPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/responsibilities" element={<ResponsibilitiesPage />} />
        <Route path="/shopping" element={<ShoppingPage />} />
        <Route path="/weekend" element={<WeekendPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/account/households" element={<AccountHouseholdsPage />} />
        <Route path="/members" element={<MembersPage />} />
        <Route path="/account/members/:memberId" element={<MemberDetailPage />} />
        <Route path="/cookbook" element={<CookbookPage />} />
        <Route path="/admin/cookbook" element={<AdminCookbookPage />} />
      </Route>

      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/auth/action" element={<AuthActionPage />} />
      </Route>

      <Route element={<OnboardingLayout />}>
        <Route path="/onboarding" element={<OnboardingPage />} />
      </Route>

      <Route element={<JoinLayout />}>
        <Route path="/join" element={<JoinPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
